export default __webpack_public_path__ + "static/media/product_NPC_Cn.35fe352a.webp";